import { Box, Flex } from "rebass";
import { HiMenu } from "react-icons/hi";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";

import { ReactComponent as HeaderLogo } from "../../../assets/images/logo/headerLogo.svg";
import { SidebarExpandedState } from "../../State/sidebar";
import { pathExcludesNavigation } from "../../Utilities/Navigation/utils";
import { useIsDesktopApp } from "../../Hooks/useIsDesktopApp";
import { useIsMobileApp } from "../../Hooks/useIsMobileApp";
import { AuthenticatedSection } from "./AuthenticatedSection";
import { UserSearch } from "../UserSearch";

const SiteHeader = ({ standalone }: { standalone?: boolean }) => {
  const [expanded, setExpanded] = useRecoilState(SidebarExpandedState);
  const { pathname: path } = useLocation();
  const isDesktopView = useIsDesktopApp();
  const isMobileApp = useIsMobileApp();

  if (standalone)
    return (
      <SiteHeaderContainer>
        <StandaloneWrapper>
          <Link to="/">
            <StyledHeaderLogo />
          </Link>
          <Box ml="auto" pr={[0, 0, 4]}>
            <AuthenticatedSection />
          </Box>
        </StandaloneWrapper>
      </SiteHeaderContainer>
    );

  if (
    pathExcludesNavigation(path) ||
    isDesktopView.isDesktop ||
    isMobileApp.isMobileApp
  )
    return <></>;

  return (
    <SiteHeaderContainer>
      <LeftGroup>
        <Box onClick={() => setExpanded(!expanded)}>
          <StyledHiMenu />
        </Box>
        <Link to="/">
          <StyledHeaderLogo />
        </Link>
        <SearchSlot>
          <UserSearch />
        </SearchSlot>
      </LeftGroup>
      <Box pr={[0, 0, 4]}>
        <AuthenticatedSection />
      </Box>
    </SiteHeaderContainer>
  );
};

const StandaloneWrapper = styled(Flex)`
  align-items: center;
  max-width: 2000px;
  width: 100%;
`;

const LeftGroup = styled(Flex)`
  align-items: center;
  flex: 1;
  gap: 36px;
  min-width: 0;
`;

const SearchSlot = styled(Box)`
  flex: 1;
  max-width: 560px;
  min-width: 0;
`;

const StyledHeaderLogo = styled(HeaderLogo)`
  height: 26px;
  width: auto;

  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    height: 22px;
  }
`;

const SiteHeaderContainer = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy600};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
  justify-content: space-between;
  padding: 18px 28px;
  position: relative;
  z-index: 101;
`;

const StyledHiMenu = styled(HiMenu)`
  color: ${({ theme }) => theme.colors.chalk};
  cursor: pointer;
  height: 24px;
  width: 24px;

  :hover {
    color: ${({ theme }) => theme.colors.envy};
  }
`;

export { SiteHeader };
